import React from "react";
import {css} from "@panda/css";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {noop} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

import {FilterFooter} from "../search/components/filters/SearchFiltersFooter";
import {FilterBudget} from "../search/components/generic_filters/FilterBudget";

interface IProps {
    label: string;
    onClear: () => void;
    closeForm: () => void;
    maxPrice?: number;
}

export const PropertyListFiltersBudget = (props: IProps) => {
    const {isMobile} = useUserDevice();

    return (
        <div className={formStyle}>
            <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")} mb={2}>
                {props.label}
            </Text>
            <FilterBudget maxPrice={props.maxPrice} maxDisplayLabel="Bez limitu" />
            {!isMobile && (
                <FilterFooter
                    onCancel={() => {
                        props.onClear();
                        props.closeForm();
                    }}
                    onSave={noop}
                />
            )}
        </div>
    );
};

const formStyle = css({
    md: {
        minWidth: "495px"
    }
});
import React from "react";
import {css} from "@panda/css";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {noop} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

import {FilterFooter} from "../search/components/filters/SearchFiltersFooter";
import {FilterBudget} from "../search/components/generic_filters/FilterBudget";

interface IProps {
    label: string;
    onClear: () => void;
    closeForm: () => void;
    maxPrice?: number;
}

export const PropertyListFiltersBudget = (props: IProps) => {
    const {isMobile} = useUserDevice();

    return (
        <div className={formStyle}>
            <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")} mb={2}>
                {props.label}
            </Text>
            <FilterBudget maxPrice={props.maxPrice} maxDisplayLabel="Bez limitu" />
            {!isMobile && (
                <FilterFooter
                    onCancel={() => {
                        props.onClear();
                        props.closeForm();
                    }}
                    onSave={noop}
                />
            )}
        </div>
    );
};

const formStyle = css({
    md: {
        minWidth: "495px"
    }
});
